// サイドバーのタブIDを定義する定数
// AnytimeConsultationSidebarコンポーネントの各タブに対応する
export const SIDEBAR_TAB_IDS = {
  SIMILAR_SEARCH: "similarSearch",  // 過去事例検索
  AI_CORRECTION: "aiCorrection",    // AI添削
  JOURNAL: "journal",               // ジャーナル検索
};
